import { Element, useNode } from "@craftjs/core";
import { Actions } from "src/types";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import Button from "@/components/editor/primitives/button/button-component";
import Image from "@/components/editor/primitives/image/image-component";
import RichText from "@/components/editor/primitives/rich-text";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
} from "@/components/editor/shared/block-wrapper";
import { IMAGE_UPLOAD_TYPES } from "@/features/analytics";

import {
  DEFAULT_DIVIDER_PICTURE_CTA_TEXT,
  DEFAULT_DIVIDER_PICTURE_DESCRIPTION,
  DEFAULT_DIVIDER_PICTURE_SUBTITLE,
} from "./constants";
import { ButtonWrapper, ImageWrapper, Wrapper } from "./divider-picture-styles";

type DividerPictureProps = {
  backgroundImage?: string;
};

export default function DividerPicture({
  backgroundImage,
}: DividerPictureProps) {
  const {
    connectors: { connect },
    id: nodeId,
  } = useNode();

  return (
    <BlockBackgroundColorWrapper ref={connect} id={nodeId}>
      <BlockMaxWidthWrapper>
        <Wrapper>
          <ImageWrapper>
            <Element
              id="divider-picture-image"
              is={Image}
              src={backgroundImage}
              blockType={IMAGE_UPLOAD_TYPES.DIVIDER_AND_PICTURE}
            />
          </ImageWrapper>
          <Element
            id="divider-picture-sub-title"
            is={RichText}
            text={`<h3 style='text-align: center;'>${DEFAULT_DIVIDER_PICTURE_SUBTITLE}</h3>`}
          />
          <Element
            id="divider-picture-description"
            is={RichText}
            text={`<p style='text-align: center;'>${DEFAULT_DIVIDER_PICTURE_DESCRIPTION}</p>`}
          />
          <ButtonWrapper>
            <Element
              id="divider-picture-cta-button"
              is={Button}
              text={DEFAULT_DIVIDER_PICTURE_CTA_TEXT}
              action={{ kind: Actions.TicketSelector }}
            />
          </ButtonWrapper>
        </Wrapper>
      </BlockMaxWidthWrapper>
    </BlockBackgroundColorWrapper>
  );
}

DividerPicture.craft = {
  custom: {
    displayName: "Divider & Picture",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
  },
};
